module.exports = __webpack_public_path__ + "static/media/i3.d1f9dc23.jpg";